// extracted by mini-css-extract-plugin
export default {"mainWrapper":"styles_mainWrapper__oHbjY","coinText":"styles_coinText__wMD8j","coinIcon":"styles_coinIcon__aD44Q","price":"styles_price__HDE7H","marker":"styles_marker__nchTN"};